// @flow

import React, {Component, type Node} from 'react';
import './TruncatedText.less';
const defaultLineHeight = 24;

type Props = {
    lines?: number /* cardinal integer */,
    lineHeight?: number /* pixels */,
    className: string,
    children: Node,
    id: string
};

type State = {
    isTruncationNeeded: boolean
};

class TruncatedText extends Component<Props, State> {
    container: ?HTMLDivElement;

    constructor(props: Props) {
        super(props);
        this.state = {
            isTruncationNeeded: true
        };
    }

    componentDidMount = () => {
        this.setState({
            isTruncationNeeded: this.isTruncationNeeded()
        });
    };

    isTruncationNeeded = (): boolean => {
        /* lineheight here HAS to match the css for any children , but not sure how to get around it */
        const {lines = 1, lineHeight = defaultLineHeight} = this.props;
        const maxContainerHeight = lines * lineHeight;
        const containerHeight: number =
            (this.container && this.container.scrollHeight) || 0;

        return containerHeight > maxContainerHeight;
    };

    render() {
        const {
            children,
            className,
            id,
            lines = 1,
            lineHeight = defaultLineHeight
        } = this.props;
        const {isTruncationNeeded} = this.state;
        const heightString = `${lines * lineHeight}px`;
        return (
            <div
                id={id}
                style={{maxHeight: heightString}}
                className={`TruncatedText ${className}`}
                ref={(c) => {
                    /* istanbul ignore next */
                    this.container = c;
                }}
            >
                {children}
                {isTruncationNeeded && (
                    <div
                        style={{height: lineHeight}}
                        className="TruncatedText__endPiece"
                    />
                )}
            </div>
        );
    }
}

export default TruncatedText;
